// @ts-nocheck
import AppConfigs from "configs/env";
import { END_POINTS } from "constants/apiUrl";
import { APIUtils } from "utils";

export const createTurnApi = (payload) => {
  return APIUtils.post(END_POINTS.CREATE_TURN_URL, {
    body: payload,
  });
};

export const spinApi = (payload) => {
  return APIUtils.post(END_POINTS.SPIN_URL, {
    body: payload,
  });
};

export const topupApi = (payload) => {
  return APIUtils.post(END_POINTS.TOPUP_URL, {
    body: payload,
  });
};
export const exchangeCodeApi = (payload) => {
  return APIUtils.post(END_POINTS.EXCHANGE_CODE_URL, {
    body: payload,
  });
};
